'use strict';
angular.module('TurneroApp').service('grupoUsuarioService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/GrupoUsuario/:id', { id: '@Id_Grupo_Usuario' }, {
        query: {
            method: 'GET',
            isArray: true
        },
        getInfo: {
            method: 'GET',
            params: {
                id_centro_atencion: 'id_centro_atencion',
                id_Grupo_Usuario: 'id_Grupo_Usuario'
            },
            url: portal.getUrlServer() + 'api/GrupoUsuario/getInfo/'
        },
        getfiltro: {
            method: 'GET',
            withcredentials: true,
            params: {
                id_Centro_Atencion: '@id_Centro_Atencion',
                nro_Pagina: '@nro_Pagina',
                tam_Pagina: '@tam_Pagina',
                texto: '@texto'
            },
        },
        save: {
            method: 'POST'
        },
        'delete': {
            method: 'DELETE'
        },
        update: {
            method: 'PUT'
        },
        Traer_Grupo_Usuarios_Activos_Combo: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/GrupoUsuario/Traer_Grupo_Usuarios_Activos_Combo/'
        }
    });
}]);


// WEBPACK FOOTER //
// ./app/components/grupos/grupos-usuarios/grupoUsuariosService.js